import React from 'react';

import {PillAvatar} from 'ccm/art/MedicalIcons';
import InfoCard from './InfoCard';

export default function BloodSugarCard(props) {
    return (
        <InfoCard
            color='blue'
            Avatar={PillAvatar}
            title='Medications'
            {...props}
        ></InfoCard>
    );
}
